import { render, staticRenderFns } from "./updateStatus.vue?vue&type=template&id=29f01144&"
import script from "./updateStatus.vue?vue&type=script&lang=js&"
export * from "./updateStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports